import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import styles from './PostFeaturedCarousel.css';

const autoplaySpeed = 3500;

class PostFeaturedCarousel extends Component {
  static propTypes = {
    imageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    images: [],
  };

  state = {
    isVisible: false,
    timeoutID: null,
  };

  componentWillUpdate(nextProps, nextState) {
    if (nextState.isVisible && !this.state.timeoutID) {
      const timeoutID = setTimeout(() => {
        if (this.refs.slider) {
          this.refs.slider.slickGoTo(1);
        }
      }, autoplaySpeed);
      this.setState({ timeoutID: timeoutID });
    }
  }

  componentWillUnmount() {
    const { timeoutID } = this.state;
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  }

  onChange(isVisible) {
    if (!this.state.isVisible && isVisible) {
      this.setState({
        isVisible: isVisible,
      });
    }
  }

  renderSlides(title, imageUrls) {
    const settings = {
      dots: true,
      autoplay: true,
      autoplaySpeed: autoplaySpeed,
    };
    const slides = imageUrls.map((url, idx) => (
      <div className={styles.img} key={idx}>
        <div className={styles.content} style={{ backgroundImage: `url(${url}?w=1040&fm=jpg&fl=progressive)` }} />
      </div>
    ));

    return (
      <VisibilitySensor
        onChange={this.onChange.bind(this)}
        partialVisibility={true}
      >
        <Slider ref="slider" {...settings}>
          {slides}
        </Slider>
      </VisibilitySensor>
    );
  }

  renderSingleImage(title, imageUrl) {
    return (
      <VisibilitySensor
        onChange={this.onChange.bind(this)}
        partialVisibility={true}
      >
        <div className={styles.img}>
          <div className={styles.content} style={{ backgroundImage: `url(${imageUrl}?w=1040&fm=jpg&fl=progressive)` }} />
        </div>
      </VisibilitySensor>
    );
  }

  render() {
    const { title, imageUrls } = this.props;
    const { isVisible } = this.state;

    return (
      <div
        className={classnames(styles.contentCarousel, {
          'animated fadeInUp': isVisible,
        })}
      >
        {imageUrls.length > 1 && this.renderSlides(title, imageUrls)}
        {imageUrls.length === 1 && this.renderSingleImage(title, imageUrls[0])}
      </div>
    );
  }
}

export default PostFeaturedCarousel;



// WEBPACK FOOTER //
// ./src/components/post-featured-carousel/PostFeaturedCarousel.js